import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"

export const TopBanner = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const DisplayName = styled.p`
  font-size: 24px;
  font-weight: 700;
  line-height: 140%;
  margin: 0;
`

export const PlacementOrInterviewStatus = styled.p`
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background-color: #e5f7fc;
  margin: 0;
`

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${breakpoint("tablet")`
    ${({ hasEmployer }) =>
      hasEmployer
        ? css`
            flex-direction: row;
          `
        : css`
            flex-direction: column;
          `}
    align-items: flex-start;
  `}
`

export const Badge = styled.div`
  font-size: 13px;
  font-style: normal;
  font-weight: 600;
  line-height: 150%;
  font-family: ${({ theme }) => theme.fonts.body.family}, sans-serif;
  background-color: ${({ theme }) => theme.colors.profile.badge.background};
  color: ${({ theme }) => theme.colors.profile.badge.text};
  border-radius: 4px;
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  text-wrap: nowrap;
`

export const Buttons = styled.div`
  display: none;

  ${breakpoint("tablet")`
  display: flex;
  gap: 12px;
  margin-top: 8px;
`}
`

export const InfoBox = styled.div`
  display: flex;
  flex-direction: column;
  color: white;

  ${breakpoint("tablet")`
    margin-left: 48px;
  `}
`

export const NameAndStatus = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
  margin-top: 32px;

  ${breakpoint("tablet")`
    flex-direction: row;
    margin-top: 12px;
    margin-bottom: 6px;
  `}
`

export const Name = styled.h3`
  font-family: "Helvetica Neue";
  font-style: normal;
  font-weight: 700;
  line-height: 110%;
  letter-spacing: -1px;
  margin: 0 8px 0 0;
  display: block;
  text-align: center;
  width: 100%;
  font-size: 28px;

  ${breakpoint("tablet")`
    display: inline;
    text-align: left;
    width: unset;
    font-size: 32px;
    margin: 0 4px 0 0;
  `}
`

export const OtherInfo = styled.div`
  display: flex;
  font-style: normal;
  font-weight: 500;
  line-height: 150%;
  gap: 8px;
  margin-bottom: 4px;
  font-size: 18px;
  justify-content: center;

  ${({ employer }) =>
    employer &&
    css`
      text-align: center;
      display: block;
    `}

  ${breakpoint("tablet")`
    font-size: 16px;
    justify-content: left;

      ${({ employer }) =>
        employer &&
        css`
          text-align: left;
          display: flex;
        `}

  `}
`

export const DesktopOnly = styled.div`
  display: none;

  ${breakpoint("tablet")`
    display: inline-block;
  `}
`
